



import Page from '../PostSales/sale/PostSale.vue'
export default {
  name: 'postsaleODM',
  components: { Page },
}
